// extracted by mini-css-extract-plugin
module.exports = {"articles":"News_articles__QAiHm"};